import { FilterProps } from "./filter-definition";
import { RadioButtonDateFilter } from "./GenericFilters/RadioButtonDateFilter";

export const ShipDateFilter = (props: FilterProps) => (
  <RadioButtonDateFilter {...props} filterKey="shipDate" name="Ship Date" />
);
